import { initializeAnalytics } from "@utils/analytics";
import EventDataLayer from "@utils/analytics/queue/EventDataLayer";
import { initializeBazaarVoice } from "@utils/bazaarInvoice";

import * as FeatureToggleService from "@services/featureToggles.services";
import * as HooksService from "@services/hooks.services";
import { removeRecentlyViewed } from "@services/recentlyViewedProducts.service";
import * as SearchService from "@services/search.services";

import { createReduxStore } from "@redux/store";

import "./../../lib/styles/index.scss";
import "./AEMComponentStyles";
import Hydrator from "./hydrator";
import "./version";

initializeBazaarVoice();
initializeAnalytics();

if (!window.storeManager) {
    const store = createReduxStore();
    window.storeManager = store;

    import(/* webpackMode: "eager" */ "@redux/initialState").then(mod =>
        mod.resolveInitialState(store),
    );

    import(
        /* webpackMode: "eager" */ "@services/algolia/tracking/algoliaTracking.service"
    ).then(mod => {
        mod.AlgoliaTrackingService.init();

        import(
            /* webpackMode: "eager" */ "@utils/analytics/subscribers/algolia/AlgoliaSubscriber"
        ).then(mod => {
            if (!window.IS_STORYBOOK) {
                const eventDataLayer = EventDataLayer.getInstance();
                mod.AlgoliaSubscriber(eventDataLayer);
            }
        });
    });
}

const hydrator = new Hydrator(window.storeManager);

window.hydrator = hydrator;
window.clearRecentlyViewed = removeRecentlyViewed;

if (self !== top) {
    window.parent.hydrator = hydrator;
}

FeatureToggleService.init();
SearchService.init();
HooksService.init();

import(/* webpackMode: "eager" */ "./PureAEMComponents").then(mod =>
    mod.init(),
);
